import { render, staticRenderFns } from "./HotelContent.vue?vue&type=template&id=3eee895d&scoped=true&"
import script from "./HotelContent.vue?vue&type=script&lang=js&"
export * from "./HotelContent.vue?vue&type=script&lang=js&"
import style0 from "./HotelContent.vue?vue&type=style&index=0&id=3eee895d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eee895d",
  null
  
)

export default component.exports